"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("./styles");
var react_i18next_1 = require("react-i18next");
var ClampText = function (_a) {
    var text = _a.text, maxLines = _a.maxLines, severity = _a.severity;
    var t = (0, react_i18next_1.useTranslation)().t;
    var containerRef = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)(false), 2), isClamped = _b[0], setIsClamped = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), expanded = _c[0], setExpanded = _c[1];
    var _d = __read((0, react_1.useState)(null), 2), containerHeight = _d[0], setContainerHeight = _d[1];
    (0, react_1.useEffect)(function () {
        var container = containerRef.current;
        if (!container)
            return;
        var lineHeight = Math.ceil(parseFloat(window.getComputedStyle(container).lineHeight));
        var maxHeight = Math.ceil(lineHeight * maxLines);
        // added 2px buffer to line height to account for line height differences when used html and css
        setIsClamped(container.scrollHeight > maxHeight && container.scrollHeight - container.clientHeight > 2);
        if (expanded) {
            setContainerHeight(container.scrollHeight);
        }
        else {
            setContainerHeight(container.clientHeight);
        }
    }, [text, maxLines, expanded]);
    var toggleExpanded = function () {
        setExpanded(!expanded);
    };
    return (react_1.default.createElement(styles_1.ClampTextWrapper, null,
        react_1.default.createElement(styles_1.Container, { containerHeight: containerHeight },
            react_1.default.createElement(styles_1.TextContainer, { expanded: expanded, maxLines: maxLines, ref: containerRef, containerHeight: containerHeight }, text)),
        isClamped && (react_1.default.createElement(styles_1.StyledButton, { size: "small", color: "secondary", buttonType: "secondary", variant: "text", severity: severity, onClick: toggleExpanded }, expanded
            ? t('prism-header:show-less', 'Show Less')
            : t('prism-header:show-more', 'Show More')))));
};
exports.default = ClampText;
//# sourceMappingURL=ClampText.js.map